import {
  RegionalInstanceId,
  resolveRegionalInstanceEndpoints,
} from "../[services]/regional-instance";

export enum ReplaceableKey {
  WootingStoreURL = "{WOOTING_STORE_URL}",
}

/**
 * The key of the object is the search string
 * The value/replacer function is what calculates what to insert based on regionalId
 */
const replacerMapping: Record<
  ReplaceableKey,
  (id: RegionalInstanceId, input: string) => string
> = {
  [ReplaceableKey.WootingStoreURL]: (id) =>
    resolveRegionalInstanceEndpoints(id).store,
};

export function stringReplacer(input: string, regionalId: RegionalInstanceId) {
  let output = input;

  for (const [key, replacer] of Object.entries(replacerMapping)) {
    output = output.replaceAll(key, replacer(regionalId, input));
  }

  return output;
}
